import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const Errors = lazy(() => import('@!/Errors/containers/Errors'))
import { useAppSettings } from '@!/Hooks/useAppSettings'

const ErrorsApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: false })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <Errors status={props.status} />
      </Suspense>
    </AppProvider>
  )
}

export default ErrorsApp
